<div
  style="
    background-color: #dddddd73;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  "
>
  <!-- Mobile Top Bar (hidden on desktop) -->
  <app-mobile-top-bar
    class="d-md-none"
    *ngIf="
      !isLoginPage &&
      !isForgotPasswordPage &&
      !isResetPasswordPage &&
      !isRegistrationPage &&
      !isSubscriptionErrorPage &&
      !isRenewSubscriptionPage &&
      !isConfigSingleViewPage
    "
    [showBurger]="!isLockActive"
    [showLogout]="!isLockActive"
    (navOpen)="openMobileNav()"
  ></app-mobile-top-bar>

  <app-mobile-main-nav
    class="d-md-none"
    [isOpen]="mobileNavOpen"
    [links]="mobileNavLinks"
    (closed)="closeMobileNav()"
  ></app-mobile-main-nav>

  <!-- Side nav (hidden for calculator accounts and mobile) -->
  <app-side-navigation-menu
    *ngIf="
      accountType !== 'calculator' &&
      !isLoginPage &&
      !isForgotPasswordPage &&
      !isResetPasswordPage &&
      !isRegistrationPage &&
      !isSubscriptionErrorPage &&
      !isRenewSubscriptionPage &&
      !isConfigSingleViewPage &&
      (!isBusinessDetailsPage || !isLockActive)
    "
    class="d-none d-md-block"
  >
  </app-side-navigation-menu>

  <!-- Header bar for calculator accounts (desktop only) -->
  <nav
    class="calculator-header d-none d-md-flex"
    *ngIf="
      accountType === 'calculator' &&
      !isLoginPage &&
      !isForgotPasswordPage &&
      !isResetPasswordPage &&
      !isRegistrationPage &&
      !isSubscriptionErrorPage &&
      !isRenewSubscriptionPage &&
      !isConfigSingleViewPage &&
      (!isBusinessDetailsPage || !isLockActive)
      !isConfigSingleViewPage
    "
  >
    <div class="calculator-header-brand">
      <img src="assets/AivorLogo.png" alt="Logo" class="calculator-header-logo" />
      <span class="calculator-header-title">AIVOR</span>
    </div>
    <div class="calculator-header-nav">
      <a routerLink="/calc" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="calculator-header-link">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="2" width="16" height="20" rx="2" stroke="currentColor" stroke-width="2"/>
          <path d="M8 6H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M8 10H10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M14 10H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M8 14H10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M14 14H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <span>Calculator</span>
      </a>
      <a routerLink="/business-details" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="calculator-header-link">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 21V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V21M19 21H5M19 21H21M5 21H3M9 7H10M9 11H10M9 15H10M14 7H15M14 11H15M14 15H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Business Profile</span>
      </a>
      <a routerLink="/config" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="calculator-header-link">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" stroke="currentColor" stroke-width="2"/>
          <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
        </svg>
        <span>Settings</span>
      </a>
    </div>
    <button class="calculator-header-logout" (click)="authService.logOut()">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16 17L21 12L16 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M21 12H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>Logout</span>
    </button>
  </nav>

  <!-- Main content -->
  <div
    class="MainWrap fadeIn"
    style="flex: 1"
    [class.expanded]="isSidebarExpanded && accountType !== 'calculator'"
    [class.calculator-mode]="accountType === 'calculator'"
    [class.login-page]="isLoginPage"
    [class.registration-page]="isRegistrationPage"
    [class.forgot-password-page]="isForgotPasswordPage"
    [class.reset-password-page]="isResetPasswordPage"
    [class.subscription-error-page]="isSubscriptionErrorPage"
    [class.renew-subscription-page]="isRenewSubscriptionPage"
  >
    <router-outlet></router-outlet>
    <app-renewal-modal
      *ngIf="showRenewalModal"
      [subscriptionStatus]="currentSubscriptionStatus"
      [userEmail]="authService.getUserEmail()"
      (renewalSuccess)="onRenewalSuccess()"
    ></app-renewal-modal>
  </div>

  <!-- Mobile Bottom Navigation (hidden on desktop) -->
  <app-mobile-bottom-nav
    class="d-md-none"
    *ngIf="
      !isLoginPage &&
      !isForgotPasswordPage &&
      !isResetPasswordPage &&
      !isRegistrationPage &&
      !isSubscriptionErrorPage &&
      !isRenewSubscriptionPage
    "
  ></app-mobile-bottom-nav>

  <!-- Footer (hidden on mobile) -->
  <ng-container
    *ngIf="
      !isLoginPage &&
      !isForgotPasswordPage &&
      !isResetPasswordPage &&
      !isRegistrationPage &&
      !isSubscriptionErrorPage &&
      !isRenewSubscriptionPage
    "
    class="d-none d-md-block"
  >
    <app-footer></app-footer>
  </ng-container>

  <app-toast></app-toast>
</div>
